import { linkToString } from '@/helper/urls';
import { getAnchorList } from '@/helper/utils';
import type { PageContentStoryblok } from '@/types/component-types-sb';
import { useEffect, useRef } from 'react';

type HeaderStore = {
  setDisplayAnchorNavigation: (display: boolean) => void;
  setAnchorList: (list: ReturnType<typeof getAnchorList>) => void;
  setCtaText: (text: string) => void;
  setCtaLink: (link: string) => void;
  resetAnchorNavigationProps: (() => void) | undefined;
};

export function useHeaderSync({
  blok,
  path,
  headerStore,
}: {
  blok: PageContentStoryblok;
  path: string;
  headerStore: HeaderStore;
}): void {
  const headerStoreInitialized = useRef(false);

  useEffect(() => {
    if (headerStore.resetAnchorNavigationProps) {
      headerStore.resetAnchorNavigationProps();
    }
  }, [path, headerStore]);

  useEffect(() => {
    if (headerStore && !headerStoreInitialized.current) {
      headerStore.setDisplayAnchorNavigation(!!blok.displayAnchorNavigation);
      headerStore.setAnchorList(getAnchorList(blok));
      headerStore.setCtaText(blok.ctaText ?? '');
      headerStore.setCtaLink(linkToString(blok.ctaLink));
      headerStoreInitialized.current = true;
    }

    return () => {
      headerStoreInitialized.current = false;
    };
  }, [blok, headerStore]);
}
